module.exports = __webpack_public_path__ + "img/温度@2x.9a9b2662.png";